import { render } from "./AvatarMenu.vue?vue&type=template&id=0f7ed00f"
import script from "./AvatarMenu.vue?vue&type=script&lang=js"
export * from "./AvatarMenu.vue?vue&type=script&lang=js"

import "./AvatarMenu.vue?vue&type=style&index=0&id=0f7ed00f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__